<template>
  <div class="appAside" :class="{ closen: !sidebarToggle }">
    <div class="appAside__bg" :class="{'appAside__bg--active': !sidebarToggle}" @click="setSidebarToggle"></div>
    <div class="appAside__content">
      <router-link to="/" class="appAside__logo">
        <div>
          <div class="appAside__logo-icon">
            <img class="appAside__logo-img" src="@/assets/img/icons/logo.svg" />
          </div>
        </div>
        <div class="appAside__logo-text">
          <p class="appAside__logo-title">PASPORT</p>
          <p class="appAside__logo-subtitle">BINO</p>
        </div>
      </router-link>
      <div class="appAside__routers">
        <template v-for="(routers, index) in routersGroup">
          <div
            :key="index"
            v-if="routers.list.some((router) => router.roles.includes(role))"
            class="appAside__group"
          >
            <p class="appAside__group-title">
              {{ routers.type[$i18n.locale] }}
            </p>

            <div class="appAside__item">
              <template v-for="(router, indexRouter) in routers.list">
                <router-link
                  :key="indexRouter"
                  v-if="router.roles.includes(role)"
                  :to="router.route"
                  class="appAside__link"
                  active-class="appAside__link-active"
                  :exact="router.route === '/'"
                >
                  <div class="appAside__icon">
                    <component :is="router.svg" />
                  </div>
                  <p class="appAside__text">{{ $t(router.text) }}</p>
                  <p
                    v-if="router.count && changed_building_count"
                    class="appAside__count"
                  >
                    {{ FilterNumber(changed_building_count) }}
                  </p>
                </router-link>
              </template>
            </div>
          </div>
        </template>
      </div>
      <div class="appAside__bottom">
        <div class="appAside__group">
          <div class="appAside__item">
            <router-link
              to="/about"
              class="appAside__link"
              exact-active-class="appAside__link-active"
            >
              <div class="appAside__icon">
                <hInformationPolygon />
              </div>
              <p class="appAside__text">{{ $t("about") }}</p>
            </router-link>
            <router-link
              to="/help"
              class="appAside__link"
              exact-active-class="appAside__link-active"
            >
              <div class="appAside__icon">
                <hHelpPolygon />
              </div>
              <p class="appAside__text">{{ $t("help") }}</p>
            </router-link>
            <button class="appAside__link" @click="setSidebarToggle">
              <div class="appAside__icon">
                <hZoomInRectangle />
              </div>
              <p class="appAside__text">{{ $t("close") }}</p>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import hPieChart from "@/components/Icons/hPieChart.vue";
import iconCompany from "@/components/Icons/iconCompany.vue";
import iconObject1 from "@/components/Icons/iconObject1.vue";
import iconBuilding4 from "@/components/Icons/iconBuilding4.vue";
import hFile from "@/components/Icons/hFile.vue";
import hUsers01 from "@/components/Icons/hUsers01.vue";
import iconInvestment2 from "@/components/Icons/iconInvestment2.vue";
import iconHydroBuilding from "@/components/Icons/iconHydroBuilding.vue";
import iconBridge1 from "@/components/Icons/iconBridge1.vue";
import hInformationPolygon from "@/components/Icons/hInformationPolygon.vue";
import hHelpPolygon from "@/components/Icons/hHelpPolygon.vue";
import hZoomInRectangle from "@/components/Icons/hZoomInRectangle.vue";

export default {
  components: {
    hPieChart,
    iconCompany,
    iconObject1,
    iconBuilding4,
    hFile,
    hUsers01,
    iconInvestment2,
    iconHydroBuilding,
    iconBridge1,
    hInformationPolygon,
    hHelpPolygon,
    hZoomInRectangle,
  },
  data() {
    return {
      catlist: "",
      toggle: "close",
      togglesuv: "close",
      AppappAside: true,
      toggleHelp: false,
      org_admins: [2675, 3737, 8209, 4061],
      changed_building_count: 0,
      routersGroup: [
        {
          type: {
            cyr: "Бино ва иншоотлар",
            ru: "Здания и сооружения",
          },
          list: [
            {
              route: "/",
              roles: [
                "ministry_admin",
                "org_admin",
                "main_org_admin",
                "reservoir",
                "operator",
                "ministry",
                "admin",
                "supervisor",
              ],
              text: "statistics",
              svg: hPieChart,
            },
            {
              route: { name: "org_list" },
              roles: ["admin", "ministry", "org_admin", "ministry_admin", "main_org_admin", "supervisor"],
              text: "organizations",
              svg: iconCompany,
            },
            {
              route: "/objects",
              roles: [
                "operator",
                "admin",
                "ministry",
                "operator",
                "org_admin",
                "ministry_admin",
                "main_org_admin",
                "supervisor",
              ],
              text: "objects",
              svg: iconObject1,
            },
            {
              route: "/building-list/",
              roles: [
                "operator",
                "admin",
                "ministry",
                "org_admin",
                "ministry_admin",
                "main_org_admin",
                "supervisor",
              ],
              text: "buildings",
              svg: iconBuilding4,
              count: true,
            },
            {
              route: "/unattested-building-list/",
              roles: [
                "operator",
                "admin",
                "org_admin",
                "ministry",
                "ministry_admin",
                "main_org_admin",
                "supervisor",
              ],
              text: "unconfirmed_buildings",
              svg: iconBuilding4,
              count: true,
            },
            {
              route: "/report",
              roles: ["admin", "supervisor"],
              text: "report",
              svg: hFile,
            },
            {
              route: "/users",
              roles: ["admin", "supervisor"],
              text: "users",
              svg: hUsers01,
            },
          ],
        },
        {
          type: {
            cyr: "Маҳсус иншоотлар",
            ru: "Специальные сооружения",
          },
          list: [
            {
              route: "/investment/3",
              roles: ["operator", "admin", "org_admin", "main_org_admin"],
              text: "investment_project",
              svg: iconInvestment2,
            },
            {
              route: "/reservoir",
              roles: ["admin", "reservoir", "supervisor"],
              text: "reservoirs",
              svg: iconHydroBuilding,
            },
            {
              route: "/transport",
              roles: ["admin", "org_admin", "tf_operator", "main_org_admin", "supervisor"],
              text: "transport_facilities",
              svg: iconBridge1,
            },
          ],
        },
      ],
    };
  },
  watch: {
    '$route'(to, from) {
      if (!this.sidebarToggle && window.innerWidth < 1024) {
        this.$store.commit('setSidebarToggle', true);
      }
    }
  },
  computed: {
    unapproved_buildings() {
      return this.$store.state.unapproved_buildings;
    },
    role() {
      return localStorage.role;
    },
    me() {
      return this.$store.state.me;
    },
    sidebarToggle() {
      return this.$store.state.sidebarToggle;
    },
  },
  methods: {
    getChangedBuildingcount() {
      if (["admin", "org_admin", "operator", "main_org_admin", "supervisor"].includes(this.role)) {
        axios
          .get(`/building/specificationlist/`, { params: { type: "new" } })
          .then((res) => {
            this.changed_building_count = res.data.count;
          });
      }
    },
    FilterNumber(e) {
      if (e && e > 10) {
        return "10+";
      } else {
        return e;
      }
    },
    setSidebarToggle() {
      this.$store.commit("setSidebarToggle", !this.sidebarToggle);
    },
  },
  mounted() {
    this.getChangedBuildingcount();
  },
};
</script>

<style lang="scss" scoped>
.appAside {
  position: relative;
  min-height: 100vh;
  transition: all 0.2s linear;
  width: 300px;
  z-index: 11;
  top: 0;
  left: 0;
  @media screen and (max-width: 1280px) and (min-width: 1024px) {
    width: 100px;
    .appAside__logo {
      padding: 0;
      &-text {
        display: none;
      }
    }
    .appAside__group {
      &-title {
        display: none;
      }
      .appAside__link {
        width: max-content;
      }
      .appAside__item {
        align-items: center;
      }
      .appAside__text {
        display: none;
      }
      .appAside__count {
        display: none;
      }
    }
  }
  @media screen and (max-width: 1023px) {
    width: 300px;
    max-width: 100%;
    position: fixed;
    left: -300px;
  }
}

.appAside__content {
  display: flex;
  flex-direction: column;
  height: 100vh;
  position: fixed;
  gap: 20px;
  left: 0;
  top: 0;
  width: inherit;
  background: #ffffff;
  border-right: 1px solid #e2e8f0;
  box-sizing: border-box;
  overflow: auto;
  padding: 20px;
  padding-right: calc(20px - 1px);
  @media screen and (max-width: 1023px) {
    position: static;
    width: 100%;
  }
}
.appAside__logo {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f8fafc;
  border-radius: 16px;
  padding: 8px;
  gap: 8px;

  &-icon {
    width: 60px;
    height: 60px;
  }
  &-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  &-text {
    font-size: 28px;
    font-weight: 900;
    line-height: 80%;
    font-family: "Orbitron", sans-serif;
  }
  &-title {
    color: #3730a3;
  }
  &-subtitle {
    color: #0891b2;
  }
}
.appAside__routers {
  flex: 1;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 40px;
  min-height: 300px;
  overflow-x: hidden;
}
.appAside__group {
  &-title {
    color: #94a3b8;
    margin-bottom: 12px;
    font-size: 14px;
    line-height: 19px;
    font-weight: 600;
  }
  .appAside__item {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
  .appAside__link {
    border-radius: 12px;
    display: flex;
    align-items: center;
    text-align: left;
    gap: 10px;
    padding: 8px 16px;
    background: #f8fafc;
    color: #94a3b8;
    &:hover {
      background: #eef2ff;
      color: #3730a3;
    }
    &-active {
      background: #3730a3;
      color: #ffffff;
      &:hover {
        background: #3730a3;
        color: #ffffff;
      }
    }
  }
  .appAside__icon {
    width: 24px;
    height: 24px;
    svg {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
  .appAside__text {
    flex: 1;
    font-size: 16px;
    line-height: 22px;
    font-weight: 600;
  }
  .appAside__count {
    width: 24px;
    height: 24px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 12px;
    line-height: 16px;
    font-weight: 600;
    border-radius: 8px;
    background: #e11d48;
    color: #ffffff;
  }
}

@media screen and (min-width: 1024px) {
  .closen {
    width: 100px;
    .appAside__logo {
      padding: 0;
      &-text {
        display: none;
      }
    }
    .appAside__group {
      &-title {
        display: none;
      }
      .appAside__link {
        width: max-content;
      }
      .appAside__item {
        align-items: center;
      }
      .appAside__text {
        display: none;
      }
      .appAside__count {
        display: none;
      }
    }
  }
}
@media screen and (max-width: 1024px) {
  .closen {
    left: 0;
  }
  .appAside__bg {
    position: fixed;
    top: 0;
    left: -100vw;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    z-index: -1;
  }
  .appAside__bg--active {
    left: 0;
  }
}
</style>
